import React, { useState } from 'react';
import { Button, Dropdown, Menu, Space, message, Modal } from 'antd';
import {
  DownloadOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  PrinterOutlined
} from '@ant-design/icons';
import ReportService from '../../services/reportBuilder.service';

const ExportOptions = ({
  entity,
  criteria,
  data = [],
  filename = 'report'
}) => {
  const [exporting, setExporting] = useState(false);
  const [printModalVisible, setPrintModalVisible] = useState(false);

  const handleExport = async (format) => {
    if (!data || data.length === 0) {
      message.warning('No data to export');
      return;
    }

    setExporting(true);
    try {
      const response = await ReportService.exportReport(entity, criteria, format);

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filename}.${format}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success(`Report exported as ${format.toUpperCase()}`);
    } catch (error) {
      console.error('Export error:', error);
      message.error('Failed to export report');
    } finally {
      setExporting(false);
    }
  };

  const handlePrint = () => {
    setPrintModalVisible(true);
  };

  const handlePrintConfirm = () => {
    window.print();
    setPrintModalVisible(false);
  };

  const exportMenu = (
    <Menu>
      <Menu.Item
        key="csv"
        icon={<FileTextOutlined />}
        onClick={() => handleExport('csv')}
        disabled={exporting}
      >
        Export as CSV
      </Menu.Item>
      <Menu.Item
        key="excel"
        icon={<FileExcelOutlined />}
        onClick={() => handleExport('xlsx')}
        disabled={exporting}
      >
        Export as Excel
      </Menu.Item>
      <Menu.Item
        key="pdf"
        icon={<FilePdfOutlined />}
        onClick={() => handleExport('pdf')}
        disabled={exporting}
      >
        Export as PDF
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item
        key="print"
        icon={<PrinterOutlined />}
        onClick={handlePrint}
      >
        Print Report
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown
        overlay={exportMenu}
        trigger={['click']}
        disabled={exporting}
      >
        <Button
          icon={<DownloadOutlined />}
          loading={exporting}
        >
          {exporting ? 'Exporting...' : 'Export'}
        </Button>
      </Dropdown>

      <Modal
        title="Print Report"
        visible={printModalVisible}
        onOk={handlePrintConfirm}
        onCancel={() => setPrintModalVisible(false)}
        okText="Print"
        cancelText="Cancel"
      >
        <p>Click "Print" to open your browser's print dialog.</p>
        <p>Note: For best results, adjust print settings to landscape orientation and fit to page.</p>
      </Modal>
    </>
  );
};

export default ExportOptions;